<template>
  <a-modal
    :title="title"
    :visible="open"
    :confirm-loading="submitLoading"
    @ok="submitForm"
    @cancel="cancel"
  >
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item :label="$t('views.systemUser.resetPwd.userName')" prop="userName">
        <a-input v-model="form.userName" :disabled="true"/>
      </a-form-model-item>
      <a-form-model-item has-feedback :label="$t('views.systemUser.resetPwd.newPassword')" prop="newPassword">
        <a-input-password v-model="form.newPassword" :placeholder="$t('views.systemUser.resetPwd.newPasswordPlaceholder')" :maxLength="20" />
      </a-form-model-item>
      <a-form-model-item has-feedback :label="$t('views.systemUser.resetPwd.confirmPassword')" prop="confirmPassword">
        <a-input-password v-model="form.confirmPassword" :placeholder="$t('views.systemUser.resetPwd.confirmPasswordPlaceholder')" :maxLength="20" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>
<script>
import { resetUserPwd } from '@/api/system/user'

export default {
  name: 'ResetPassword',
  data () {
    return {
      submitLoading: false,
      open: false,
      form: {
        userName: undefined,
        newPassword: undefined,
        confirmPassword: undefined
      }
    }
  },
  computed: {
    title () {
      return this.$t('views.systemUser.resetPwd.title')
    },
    rules () {
      const validateNewPass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('views.systemUser.resetPwd.err.newPwdRequired')))
        } else if (!/^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)([^\u4e00-\u9fa5\s]){5,20}$/.test(value)) {
          callback(new Error(this.$t('views.systemUser.resetPwd.err.newPwdPattern')))
        } else {
          if (this.form.confirmPassword !== '') {
            this.$refs.form.validateField('confirmPassword')
          }
          callback()
        }
      }
      const validateConfirmPass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('views.systemUser.resetPwd.err.confirmRequired')))
        } else if (value !== this.form.newPassword) {
          callback(new Error(this.$t('views.systemUser.resetPwd.err.confirmMismatch')))
        } else {
          callback()
        }
      }
      return {
        newPassword: [
          { required: true, validator: validateNewPass, trigger: 'change' }
        ],
        confirmPassword: [
          { required: true, validator: validateConfirmPass, trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    cancel () {
      this.open = false
      this.reset()
    },
    reset () {
      this.form = {
        id: undefined,
        userName: undefined,
        newPassword: undefined,
        confirmPassword: undefined
      }
    },
    handleResetPwd (row) {
      this.form = {
        id: row.id,
        userName: row.userName
      }
      this.open = true
    },
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          resetUserPwd(this.form.id, this.form.newPassword).then(() => {
            this.$message.success(this.$t('views.systemUser.resetPwd.msg.success'), 3)
            this.open = false
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
